import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-fare-rules-filter',
  templateUrl: './fare-rules-filter.component.html',
  styleUrls: ['./fare-rules-filter.component.scss']
})
export class FareRulesFilterComponent implements OnInit {

  @Input() label = "Change";
  @Input() selectedOption = "Disallowed(All)";
  @Output() onOptionSelected = new EventEmitter();


  constructor(private translate: TranslateService) { }

  options = [];


  ngOnInit(): void {
    this.buildOptions();

    this.translate.onLangChange.subscribe(() => {
      this.buildOptions();
    });
  }

  private buildOptions(): void {
    this.options = [
      {
        name: 'Not Allowed',
        value: 'Any',
        translatedValue: this.translate.instant('FARE_RULES_FILTER.VALUES.ANY')
      },
      {
        name: 'Allowed',
        value: 'Allowed',
        translatedValue: this.translate.instant('FARE_RULES_FILTER.VALUES.ALLOWED'),
        description: this.translate.instant('FARE_RULES_FILTER.DESCRIPTIONS.ONLY_ALLOWED')
      },
      {
        name: 'For Fee',
        value: 'With Fee',
        translatedValue: this.translate.instant('FARE_RULES_FILTER.VALUES.WITH_FEE'),
        description: this.translate.instant('FARE_RULES_FILTER.DESCRIPTIONS.INCLUDES')
      }
    ];
  }

  selectOptions(option: any) {
    this.selectedOption = option.value;
    this.onOptionSelected.emit(option);
  }
}
